module.exports = __webpack_public_path__ + "static/media/exclam-circle-grey-icon.0f22fcb9.png";